import "./FilterMeshSpecifications.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import MeshSpecHero from "./sections/MeshSpecHero";
import MeshSpec from "./sections/MeshSpec";
import OrderGuide from "./sections/OrderGuide";
import RelatedArticles from "./sections/RelatedArticles";
import QuoteBanner from "./sections/QuoteBanner";
import Footer from "@/reusable_sections/Footer";
export default function FilterMeshSpecificationsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="FilterMeshSpecifications" />
      <MeshSpecHero />
      <MeshSpec />
      <OrderGuide />
      <RelatedArticles />
      <QuoteBanner />
      <Footer />
    </div>;
}